import { Table, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react';
import _ from 'lodash';
import React from 'react';

import { utils as commonUtils } from '@finley-technologies/common';

import { CreditAgreement } from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/common';

const CapitalProviderEntityConfig: React.FC<{
  _config_: CreditAgreement.DomainEntity.Items.CapitalProviderConfig;
}> = ({ _config_ }) => {
  return (
    <Table width="50%" borderWidth="1px">
      <Thead>
        <Tr>
          <Th>Name</Th>
          <Th>Value</Th>
        </Tr>
      </Thead>
      <Tbody>
        {_.map(_config_, (configProperty, key) => {
          return (
            <Tr key={key}>
              <Td>{commonUtils.toTitleCase(key)}</Td>
              <Td>{configProperty}</Td>
            </Tr>
          );
        })}
      </Tbody>
    </Table>
  );
};

export const PartyEntityConfig: React.FC<{
  partyKey: CreditAgreement.DomainEntity.Items.PartyType;
  _config_: CreditAgreement.DomainEntity.Items.CapitalProviderConfig; // | other type of configs as well
}> = ({ partyKey, _config_ }) => {
  // I suspect we will need to type cast as TS will fail to narrow _config_
  switch (partyKey) {
    case 'capitalProvider':
      return <CapitalProviderEntityConfig _config_={_config_} />;
    default:
      throw Error(`Party ${partyKey} is not configured.`);
  }
};
